module.exports = __webpack_public_path__ + "img/user_img.3ac88a09.png";